import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GROUPS_QUERY } from '../../queries';

export function useGroupListQuery( options ) {
    const { data: rawData, loading, error, refetch } = useQuery( GROUPS_QUERY, options );

    return useMemo( () => {
        return {
            error,
            loading,
            data: rawData,
            refetch,
        };
    }, [ error, loading, rawData, refetch ] );
}
